import { ListFolderContentsParams, ListFolderContentsResponse } from '@/api/generatedApi';
import { useInfiniteQuery } from '@/hooks/api/useInfiniteQuery';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getAssetsFromFolderContents } from '@/utils/assets';
import { getFoldersFromFolderContents } from '@/utils/folders';
import { LIST_FOLDER_CONTENTS_QUERY_KEY } from './useFetchFolderContents';

export const useListFolderContents = ({
  folderId,
  contentType = 'all',
  enabled = true,
}: {
  folderId: string;
  contentType?: 'folders' | 'assets' | 'all';
  enabled?: boolean;
}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const result = useInfiniteQuery<ListFolderContentsParams, ListFolderContentsResponse>({
    queryKey: [LIST_FOLDER_CONTENTS_QUERY_KEY, { folderId, contentType, tenantId }],
    queryFunction: api.folders.listFolderContents,
    queryParams: { tenantId, folderId, contentType },
    options: { enabled },
  });

  return {
    ...result,
    assets: getAssetsFromFolderContents(result.contents),
    folders: getFoldersFromFolderContents(result.contents),
  };
};
